import * as types from "../Action/type";

const initialState = {
    loading: false,
    token: null,
    error: null,
    user:null,
    language: localStorage.getItem('JazanLanguage') ? localStorage.getItem('JazanLanguage') : 'ar',
    screentype: null

}
const AuthReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.FETCH_LOGIN_REQUEST:
            return { ...state, loading: true, error: null };
        case types.FETCH_LOGIN_SUCCESS:
            return {
                ...state,
                token: action.payload.token,
                user:action.payload.user,
                screentype:action.payload.user.type,
                language: action.payload.user.language,
                loading: false
            };
        case types.REMOVE_TOKEN:
            return {
                ...state,
                token: null,
                user:null,
                loading: false,
            };
        case types.INTIALIZE_TOKEN:
            return {
                ...state,
                token: action.Payload.token,
                user: action.Payload.user,
                language: action.Payload.lang,
                loading: false,
            };
        case types.INTIALIZE_LANG:
                return {
                    ...state,
                    language: action.lang,
                    loading: false,
                };
        case types.INTIALIZE_TYPE:
                return {
                    ...state,
                    screentype: action.Payload,
                    loading: false,
                }; 
        case types.FETCH_LOGIN_FAILED:
            return {
                ...state,
                loading: false
            }
        default:
            return state;
    }

}
export default AuthReducer;